import { render, staticRenderFns } from "./TinyModal.vue?vue&type=template&id=f04607d4&scoped=true&"
import script from "./TinyModal.vue?vue&type=script&lang=js&"
export * from "./TinyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04607d4",
  null
  
)

export default component.exports